import apiconnection from '../api/general';


// Replace with your actual API endpoint
const API_URL = '/payment/transactions';


const fetchAllTransactions = async () => {
    let allTransactions = [];
    let loading = false;
    let error = null;
    let morePages = true
    let totalTransactions = 0;
    let offset = 0;

    while (morePages){
        try {
        const response = await apiconnection.get(API_URL, {
        params: {
        //   page: page,
            offset: offset,
            status: 'PAID',
        }
        });
        const data = response.data.data.transactions

        allTransactions = allTransactions.concat(data);
        // setTotalPages(Math.ceil(response.data.data.pagination.total / ITEMS_PER_PAGE));
        totalTransactions = response.data.data.pagination.total;

        if(allTransactions.length < totalTransactions){
            offset+=20;
        }else {
            morePages = false;
        }
        
        } catch (err) {
            error = err.message || 'Failed to fetch transactions';
            console.error('Error fetching transactions:', err);
        } finally {
            loading = false;
        }

    }

    return allTransactions;

};

export default fetchAllTransactions;